import { updateRelatives } from '../integrals/updateRelatives';
import { checkRangeKind } from './checkRangeKind';
export function updateRangesRelativeValues(datum, forceCalculateIntegral = false) {
    updateRelatives(datum.ranges, 'integration', checkRangeKind, forceCalculateIntegral);
}
